// import React, { useEffect, useState } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import dayjs from 'dayjs';
// import { Grid, Paper, CardHeader, CardContent, Typography, Stack, Divider, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

// function UserChart({ userData, driverData }) {
//   const [chartData, setChartData] = useState([]);
//   const [selectedYear, setSelectedYear] = useState(dayjs().year()); // Default to the current year
//   const [increasePercentage, setIncreasePercentage] = useState(0);
//   const [newProductsPurchased, setNewProductsPurchased] = useState(0);
  
//   useEffect(() => {
//     const processData = (data) => {
//       const currentYearData = data.filter(item => dayjs(item.created_at).year() === selectedYear);
//       const previousYearData = data.filter(item => dayjs(item.created_at).year() === selectedYear - 1);

//       const currentMonthCounts = Array(12).fill(0);
//       const previousMonthCounts = Array(12).fill(0);

//       currentYearData.forEach(item => {
//         const createdAt = item.created_at;
//         const month = dayjs(createdAt).month();
//         currentMonthCounts[month]++;
//       });

//       previousYearData.forEach(item => {
//         const createdAt = item.created_at;
//         const month = dayjs(createdAt).month();
//         previousMonthCounts[month]++;
//       });

//       const currentMonthIndex = dayjs().month();
//       const previousMonthIndex = currentMonthIndex === 0 ? 11 : currentMonthIndex - 1;

//       const currentMonthCount = currentMonthCounts[currentMonthIndex];
//       const previousMonthCount = previousMonthCounts[previousMonthIndex];

//       const increasePercentage = previousMonthCount !== 0
//         ? ((currentMonthCount - previousMonthCount) / previousMonthCount) * 100
//         : currentMonthCount !== 0
//         ? 100  // This means that previousMonthCount is 0 but currentMonthCount is not 0
//         : 0;

//       const newProductsPurchased = currentMonthCount - previousMonthCount;

//       return {
//         increasePercentage,
//         newProductsPurchased,
//         currentMonthCounts,
//       };
//     };

//     const userStats = processData(userData);
//     const driverStats = processData(driverData);

//     const data = Array.from({ length: 12 }, (_, index) => ({
//       x: dayjs().month(index).format('MMM'),
//       users: userStats.currentMonthCounts[index],
//       drivers: driverStats.currentMonthCounts[index],
//     }));

//     setIncreasePercentage(userStats.increasePercentage);
//     setNewProductsPurchased(userStats.newProductsPurchased);
//     setChartData(data);
//   }, [userData, driverData, selectedYear]);

//   const handleYearChange = (event) => {
//     setSelectedYear(event.target.value);
//   };

//   return (
//     <Grid container spacing={2}>
//       <Grid item xs={12}>
//         <Paper elevation={1} className="mui-zyqb0c">
//           <CardHeader
//             title="Registerd Users and Drivers"
//             className="mui-10to7so"
//             titleTypographyProps={{ variant: 'h6', sx: { color: '#667085' } }}
//             action={
//               <FormControl sx={{ minWidth: 120 }}>
//                 <InputLabel id="year-select-label">Year</InputLabel>
//                 <Select
//                   labelId="year-select-label"
//                   id="year-select"
//                   value={selectedYear}
//                   onChange={handleYearChange}
//                   sx={{ width: '100%' }}
//                 >
//                   <MenuItem value={dayjs().year()}>{dayjs().year()}</MenuItem>
//                   <MenuItem value={dayjs().year() - 1}>{dayjs().year() - 1}</MenuItem>
//                 </Select>
//               </FormControl>
//             }
//           />
//           <Divider/>
//           <CardContent className="mui-18s85xs">
//             <Grid container spacing={2}>
//               <Grid item xs={12} >
//                 <Stack direction="column" spacing={2}>
//                   <div>
//                     <Typography variant="h5" color='#15b79f'>{`${increasePercentage.toFixed(2)}%`}</Typography>
//                     <Typography variant="body1">
//                       increase in app usage with{' '}
//                       <span>{newProductsPurchased}</span> new Users
//                     </Typography>
//                   </div>
//                 </Stack>
//               </Grid>
//               <Grid item xs={12}>
//                 <div style={{ width: '100%', height: 300 }}>
//                   {chartData.length >= 1 && (
//                     <ResponsiveContainer width="100%" height="100%">
//                       <LineChart
//                         data={chartData}
//                         margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
//                       >
//                         <CartesianGrid strokeDasharray="3 3" />
//                         <XAxis dataKey="x" />
//                         <YAxis />
//                         <Tooltip />
//                         <Legend />
//                         <Line type="monotone" dataKey="users" stroke="#8884d8" name="Users" />
//                         <Line type="monotone" dataKey="drivers" stroke="#FF0000" name="Drivers" />
//                       </LineChart>
//                     </ResponsiveContainer>
//                   )}
//                 </div>
//               </Grid>
//               <Grid item xs={12}>
//                 <Divider />
//               </Grid>
//             </Grid>
//           </CardContent>
//         </Paper>
//       </Grid>
//     </Grid>
//   );
// }

// export default UserChart;


import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import dayjs from 'dayjs';
import { Grid, Paper, CardHeader, CardContent, Typography, Stack, Divider, FormControl, InputLabel, Select, MenuItem, Card } from '@mui/material';
import { RadialBarChart, RadialBar, PolarAngleAxis  } from 'recharts';



// StatsCard Component
function StatsCard({ title, total, percentage, color, chartData }) {
  const generateChartData = (statsData) => {
    if (!statsData || !statsData.currentMonthCounts) {
      return []; // Return empty array if chartData or currentMonthCounts is undefined
    }

    const currentMonthIndex = dayjs().month();
    const data = statsData.currentMonthCounts
      .slice(0, currentMonthIndex + 1)
      .map((count, index) => ({
        month: dayjs().month(index).format('MMM'),
        value: count,
      }));

    return data;
  };

  const data = generateChartData(chartData);
console.log("chart data generateChartData",data)
  return (
    <Card elevation={1}>
      <CardContent>
        <Typography variant="h6" color="textPrimary">{title}</Typography>
        <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
          <div>
            <Typography variant="h5" color="textSecondary">{total}</Typography>
            <Typography variant="body2" color="textSecondary">Total</Typography>
          </div>
          <ResponsiveContainer width="100%" height={100}>
            <LineChart data={data}>
              <XAxis dataKey="month" axisLine={false} tick={false}/>
              <YAxis axisLine={false} tick={false} />
              <Tooltip />
              <Line type="monotone" dataKey="value" stroke={color} />
            </LineChart>
          </ResponsiveContainer>
        </Stack>
      </CardContent>
    </Card>
  );
}



function StatsChart({ data }) {
  return (
    <div style={{ width: '100%', height: 300 }}>
      {data.length >= 1 && (
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="x" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Line type="monotone" dataKey="users" stroke="#8884d8" name="Users" />
            <Line type="monotone" dataKey="drivers" stroke="#FF0000" name="Drivers" />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

function UserChart({ userData, driverData }) {
  const [chartData, setChartData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(dayjs().year()); // Default to the current year
  const [userStats, setUserStats] = useState({
    increasePercentage: 0,
    newProductsPurchased: 0,
    total: 0,
    currentMonthCounts: []
  });
  const [driverStats, setDriverStats] = useState({
    increasePercentage: 0,
    newProductsPurchased: 0,
    total: 0,
    currentMonthCounts: []
  });

  useEffect(() => {
    const processData = (data) => {
      const currentYearData = data.filter(item => dayjs(item.created_at).year() === selectedYear);
      const previousYearData = data.filter(item => dayjs(item.created_at).year() === selectedYear - 1);

      const currentMonthCounts = Array(12).fill(0);
      const previousMonthCounts = Array(12).fill(0);

      currentYearData.forEach(item => {
        const createdAt = item.created_at;
        const month = dayjs(createdAt).month();
        currentMonthCounts[month]++;
      });

      previousYearData.forEach(item => {
        const createdAt = item.created_at;
        const month = dayjs(createdAt).month();
        previousMonthCounts[month]++;
      });

      const currentMonthIndex = dayjs().month();
      const previousMonthIndex = currentMonthIndex === 0 ? 11 : currentMonthIndex - 1;

      const currentMonthCount = currentMonthCounts[currentMonthIndex];
      const previousMonthCount = previousMonthCounts[previousMonthIndex];

      const increasePercentage = previousMonthCount !== 0
        ? ((currentMonthCount - previousMonthCount) / previousMonthCount) * 100
        : currentMonthCount !== 0
          ? 100  // This means that previousMonthCount is 0 but currentMonthCount is not 0
          : 0;

      const newProductsPurchased = currentMonthCount - previousMonthCount;
      const total = currentYearData.length;

      return {
        increasePercentage,
        newProductsPurchased,
        total,
        currentMonthCounts,
      };
    };

    const userStats = processData(userData);
    const driverStats = processData(driverData);
console.log("USErStats",userStats)
console.log("driverStats",driverStats);
    const data = Array.from({ length: 12 }, (_, index) => ({
      x: dayjs().month(index).format('MMM'),
      users: userStats.currentMonthCounts[index],
      drivers: driverStats.currentMonthCounts[index],
    }));

    setUserStats(userStats);
    setDriverStats(driverStats);
    setChartData(data);
  }, [userData, driverData, selectedYear]);

  const handleYearChange = (event) => {
    setSelectedYear(event.target.value);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={9}>
        <Paper elevation={1} className="mui-zyqb0c">
          <CardHeader
            title="Registered Users and Drivers"
            className="mui-10to7so"
            titleTypographyProps={{ variant: 'h6', sx: { color: '#667085' } }}
            action={
              <FormControl sx={{ minWidth: 120 }}>
                <InputLabel id="year-select-label">Year</InputLabel>
                <Select
                  labelId="year-select-label"
                  id="year-select"
                  value={selectedYear}
                  onChange={handleYearChange}
                  sx={{ width: '100%' }}
                >
                  <MenuItem value={dayjs().year()}>{dayjs().year()}</MenuItem>
                  <MenuItem value={dayjs().year() - 1}>{dayjs().year() - 1}</MenuItem>
                </Select>
              </FormControl>
            }
          />
          <Divider />
          <CardContent className="mui-18s85xs">
            <StatsChart data={chartData} />
          </CardContent>
        </Paper>
      </Grid>
      <Grid item xs={3}>
        <Paper elevation={1}>
          <CardContent>
            <Stack spacing={2}>
              <StatsCard
                title="User Registrations"
                total={userStats.total}
                percentage={userStats.increasePercentage}
                color='#15b79f'
                chartData={userStats}
              />
              <StatsCard
                title="Driver Registrations"
                total={driverStats.total}
                percentage={driverStats.increasePercentage}
                color='#FF0000'
                chartData={driverStats}
              />
            </Stack>
          </CardContent>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default UserChart;





